import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Option } from '../../models/option.model';
import { Qna } from '../../models/qna.model';
import { DataService } from '../../services/data.service';
import { ValidateService } from './../../services/validate.service';

@Component({
  selector: 'app-security-question',
  templateUrl: './security-question.component.html',
  styleUrls: ['./security-question.component.scss'],
  providers: [DataService, ValidateService]
})
export class SecurityQuestionComponent implements OnInit {
  public questions: Array<Option>;
  public formGroup: FormGroup;

  @Input() public qna: Qna;
  @Output() private qnaChanged: EventEmitter<Qna> = new EventEmitter();

  constructor(
    private formBuilder: FormBuilder,
    private dataService: DataService,
    private validateService: ValidateService
  ) {}

  ngOnInit() {
    this.formGroup = this.createSecurityAnswerForm();
    this.formGroup.valueChanges.subscribe(val => {
      this.changedQna();
    });

    this.dataService.getSecurityQuestions().subscribe(data => {
      this.setOptions(data);
    });
  }

  private setOptions(questions: Array<Option>) {
    this.questions = questions;
    this.qna.question = this.qna.question ? this.qna.question : this.questions[0].value;
  }

  private configureSecurityAnswerInput() {
    this.qna.answer = this.formGroup.get('answer').value;
  }

  private changedQna() {
    this.configureSecurityAnswerInput();
    this.qnaChanged.emit(this.qna);
  }

  private createSecurityAnswerForm(): FormGroup {
    return this.formBuilder.group({
      answer: [this.qna.answer, Validators.required]
    });
  }
}
